import { createTheme, MantineColorsTuple } from '@mantine/core';

// Custom palette: #5C3973, #181126, #FF6600, #FF7200, #FF5200, #F23827, #F2F2F2
const orange: MantineColorsTuple = [
  '#fff3ea',
  '#ffe3d1',
  '#ffc9a8',
  '#ffac7a',
  '#FF7200',
  '#FF6600',
  '#FF5200',
  '#e64700',
  '#cc3f00',
  '#b33600'
];

const plum: MantineColorsTuple = [
  '#f3eef7',
  '#e4d9ec',
  '#ccb3d9',
  '#b389c6',
  '#9d67b5',
  '#8d52aa',
  '#7f47a5',
  '#6d3890',
  '#5C3973',
  '#4a2d5d'
];

const crimson: MantineColorsTuple = [
  '#ffe9e6',
  '#ffd0cc',
  '#ffa199',
  '#ff6e61',
  '#ff4230',
  '#F23827',
  '#d92515',
  '#c01a0d',
  '#9f1409',
  '#661005'
];

export const theme = createTheme({
  colors: {
    orange,
    plum,
    crimson
  },
  primaryColor: 'orange',
  primaryShade: 5,
  fontFamily: '"Montserrat", system-ui, -apple-system, "Segoe UI", sans-serif',
  headings: {
    fontFamily: '"Montserrat", system-ui, -apple-system, "Segoe UI", sans-serif',
    fontWeight: '700'
  },
  defaultRadius: 'md',
  other: {
    darkBg: '#181126',
    lightBg: '#F2F2F2'
  }
});
